<template>
  <div
    class="bg-white px-3"
    style="margin: -20px; margin-top: -1rem; margin-bottom: 0 !important"
  >
    <div class="mb-2 mt-2 pt-3 sertop">
      <!-- 左边 -->
      <div class="sertop-left">
        <template>
          <el-button
            type="primary"
            @click="exupad"
            size="medium"
            :loading="exupadload"
            >导出</el-button
          >
        </template>
      </div>

      <div class="sertop-right">
        <el-form inline ref="form" :model="from" label-width="100px">
          <el-form-item label="" size="small" class="mb-0">
            <el-date-picker
              v-model="from.date"
              type="daterange"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            >
            </el-date-picker>
          </el-form-item>

          <el-form-item class="mb-0">
            <el-button type="info" @click="searchEvent" size="small"
              >搜索
            </el-button>
            <el-button size="small" @click="clearSearch"
              >清空筛选条件</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </div>

    <!-- 表格 -->
    <div class="mt-3 pt-2">
      <el-table
        :data="tableData"
        @sort-change="sortChange"
        border
        style="width: 100%"
        @selection-change="handleSelectionChange"
      >
        <!-- <el-table-column type="selection" width="45" align="center">

				</el-table-column> -->
        <el-table-column
          fixed
          align="center"
          type="index"
          label="排序"
          width="50"
        >
        </el-table-column>
        <el-table-column
          align="center"
          min-width="120"
          prop="card_number"
          label="主播信息"
        >
          <template slot-scope="v">
            <el-avatar :src="v.row.user.head"></el-avatar>
            <div>{{ v.row.user.nickname }}</div>
            <div><span class="text-warning">ID：</span>{{ v.row.user.id }}</div>

            <div>
              <span class="text-warning">账号：</span>{{ v.row.user.username }}
            </div>
          </template>
        </el-table-column>

        <el-table-column align="center" prop="name" label="赛程类型">
          <template slot-scope="v">
            <span v-if="v.row.type_id == 1">足球</span>
            <span v-if="v.row.type_id == 2">篮球</span>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="com_name" label="联赛分类名称">
        </el-table-column>
        <el-table-column align="center" prop="match_name" label="赛程名称">
        </el-table-column>
        <el-table-column
          align="center"
          sortable="custom"
          prop="total_num"
          label="直播间总人数"
        >
        </el-table-column>
        <el-table-column align="center" prop="name" label="状态">
          <template slot-scope="v">
            <span v-if="v.row.status == 1">直播中</span>
            <span v-if="v.row.status == 2">已下播</span>
          </template>
        </el-table-column>

        <el-table-column
          sortable="custom"
          align="center"
          prop="play_time"
          width="200"
          label="开赛时间"
        >
        </el-table-column>
        <el-table-column
          sortable="custom"
          align="center"
          prop="match_time"
          width="200"
          label="开播时间"
        >
        </el-table-column>
      </el-table>
    </div>

    <div style="height: 60px"></div>
    <el-footer
      class="d-flex border-top bg-white align-items-center px-0 position-fixed"
      style="bottom: 0; left: 200px; right: 0; z-index: 100"
    >
      <!-- 底部 -->

      <div style="flex: 1" class="px-2">
        <el-pagination
          :current-page="page.current"
          :page-sizes="page.sizes"
          :page-size="page.size"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          layout="total, sizes, prev, pager, next, jumper"
          :total="page.total"
        >
        </el-pagination>
      </div>
    </el-footer>
  </div>
</template>

<script>
import common from "@/common/mixins/common.js";
import ExportJsonExcel from "js-export-excel";
// import buttonSearch from "@/components/common/button-search.vue";
export default {
  //   components: {
  //     buttonSearch,
  //   },
  inject: ["layout"],
  mixins: [common],
  data() {
    return {
      createModel: false,
      editIndex: -1,
      //搜索数据
      from: {
        date: [],
        is_excel: 0,
      },
      model_title: "Host",
      auth_val: "Mtlog",
      preUrl: "data/hostupList", //列表地址

      tableData: [],
      form: {
        id: 0,
        remark: "",
      },
      exupadload: false,
      prop: "play_time",
      sort: "descending",
      rules: {
        remark: [
          {
            required: true,
            message: "请输入拒绝原因",
            trigger: "blur",
          },
        ],
      },
      rule_list: [],
      check_img_list: [],
      cz_money: 0,
      tx_money: 0,
    };
  },
  created() {
    //this.commonList('rule');
  },
  methods: {
    sortChange(column) {
      this.prop = column.prop;
      this.sort = column.order;
      this.getList();
    },
    //提交
    submit() {
      this.$refs.form.validate((res) => {
        if (res) {
          //this.form.default = this.form.default.replace(/\n/g,',')
          this.form.id = this.editIndex;
          this.addOrEdit(this.form);
          // 关闭模态框
        }
      });
    },

    // 打开模态框
    openModel(e, type) {
      // 修改
      this.form = {
        id: e.id,
        remark: "",
        type: 2,
      };
      this.editIndex = e.id;
      // 打开dialog
      this.createModel = true;
    },

    getListResult(e) {
      this.tableData = e.list;
      this.cz_money = e.cz_money;
      this.tx_money = e.tx_money;
      console.log(this.tableData);
      this.check_img_list = e.list.map((item) => {
        return item.head;
      });
    },
    // 清空筛选条件
    clearSearch() {
      this.from = {
        date: [],
        is_excel: 0,
      };
      //   this.$refs.buttonSearch.closeSuperSearch();
      this.search = "";
      this.getList();
    },

    // 导出
    exupad() {
      this.exupadload = true;
      this.api
        .post("/data/hostupList", {
          search: {
            date: this.from.date,
          },
          is_excel: 1,
          page: this.page.current,
          limit: this.page.size,
        })
        .then((res) => {
          console.log(res.data.data.list);
          this.exportExcel(res.data.data.list);
          this.exupadload = false;
        })
        .catch((err) => {
          this.exupadload = false;
        });
    },
    exportExcel(value) {
      // 调用插件导出文件
      const dataList = value.list;
      let option = {}; //   option代表的就是excel文件
      let dataTable = []; //   dataTable代表excel文件中的数据内容
      let sheetHeaderdata = [
        "名称",
        "ID",
        "账号",
        "赛程类型",
        "联赛分类名称",
        "赛程名称",
        "直播间总人数",
        "状态",
        "开赛时间",
        "开播时间",
      ]; // 表头
      if (dataList) {
        for (let i in dataList) {
          dataTable.push({
            名称: dataList[i].user.nickname,
            ID: dataList[i].user.id,
            账号: dataList[i].user.username,
            赛程类型: dataList[i].type_id == 1 ? "足球" : "篮球",
            联赛分类名称: dataList[i].com_name,
            赛程名称: dataList[i].match_name,
            直播间总人数: dataList[i].total_num,
            状态: dataList[i].status == 1 ? "直播中" : "已下播",
            开赛时间: dataList[i].play_time,
            开播时间: dataList[i].match_time,
          }); //   设置excel每列获取的数据源
        }
      }
      let name = "";
      if (value.end_date != value.start_date) {
        name = value.end_date + "至" + value.start_date + "的主播赛事数据";
      } else {
        name = value.end_date + "的主播赛事数据";
      }
      option.fileName = name; //excel文件名
      //excel文件数据
      option.datas = [
        {
          //   excel文件的数据源
          sheetData: dataTable,
          //   excel文件sheet的表名
          sheetName: "sheet",
          //   excel文件表头名
          sheetHeader: sheetHeaderdata,
          //   excel文件列名
          sheetFilter: sheetHeaderdata,
          // 宽度
          columnWidths: ["8", "4"],
        },
      ];
      //   创建ExportJsonExcel实例对象
      let toExcel = new ExportJsonExcel(option);
      //   调用保存方法
      toExcel.saveExcel();
    },
  },
};
</script>

<style lang="scss" scoped>
.sertop {
  display: flex;
  align-items: center;
  justify-content: space-between;
  //   .sertop-left {
  //     display: inline-block;
  //     width: 70px;
  //     text-align: center;
  //     margin-left: 20px;
  //     color: #ffffff;
  //     font-size: 14px;
  //     padding: 2px 5px;
  //     cursor: pointer;
  //     background-color: #008080;
  //   }
}
::v-deep .el-form-item__content,
::v-deep.el-form--inline .el-form-item {
  vertical-align: middle;
}
</style>
